<template>
<div>
	<modal-dialog :title="modalTitle"
		:modal-visible="visible"
		confirm-button-text="Save"
		:working="working"
		:submit-visible="userCanWriteEvent"
		modal-size="modal-lg"
		v-on:closeModal="$emit('closeModal')"
		v-on:confirm="saveModalEdit">

		<h5>
			<router-link v-if="(payload.type == 'project' || payload.type == 'service') && (eventService || eventProject)" :to="
					eventService ? '/service/'+eventService.slug+'/dashboard' : '/project/'+eventProject.slug+'/dashboard' 
				">
				{{payload.description}}
			</router-link>
			<router-link v-else-if="payload.type == 'user' && eventUser" :to="'/employee/'+eventUser.slug+'/profile'">
				{{eventUser.first_name}} {{eventUser.last_name}}
			</router-link>
			<router-link v-else-if="payload.type == 'equipment' && eventEquipment" :to="'/equipment/edit/'+eventEquipment.slug+'/log'">
				{{payload.description}}
			</router-link>
			<template v-else>
				{{payload.description}}
			</template>
			<div v-if="payload.type == 'user' || payload.type == 'equipment'"><small>
				<router-link v-if="eventService" :to="'/service/'+eventService.slug+'/dashboard'">
					Service #{{eventService.job_num}}
				</router-link>
				<router-link v-else-if="eventProject" :to="'/project/'+eventProject.slug+'/dashboard'">
					Project #{{eventProject.job_num}}
				</router-link>
			</small></div>
		</h5>

		<event-employee-entity-picker v-if="payload.type == 'user' && !payload.user_id"
			:selected-date="payload.startDate"
			:events-list="eventsList"
			v-on:userSelected="userSelected">
		</event-employee-entity-picker>

		<equipment-picker v-else-if="payload.type == 'equipment' && !payload.equipment_id"
			:hide-meta="true"
			v-model="payload.equipment_id">
		</equipment-picker>

		<!--
		<div v-if="record.type == 'equipment'">
			<job-picker
				v-if="!+payload.service_id" 
				label="Assign to Project" 
				col-class="col-md-5" 
				job-type="project"
				v-model="payload.job_id"
				v-on:change="jobChange">
			</job-picker>

			<job-picker
				v-if="!+payload.job_id" 
				label="Assign to Service" 
				col-class="col-md-5" 
				job-type="service"
				v-model="payload.service_id"
				v-on:change="jobChange">
			</job-picker>
		</div>
		-->


		<alert v-if="record.is_vacation == 1 && !record.ApprovedBy" classes="alert-info" message="Pending approval" :unclosable="true" :visible="true"></alert>

		<template v-if="record.type == 'project' || record.type == 'service'">

			<div class="row">
				<div class="col-md-6">
					<form-group :label="record.type == 'project' ? 'Project Start/End Date' : 'Service Start/End Date'"
						col-class="stacked">

						<div class="d-flex">
							<field
								:params="{type:'date'}"	
								:readonly="!userCanWriteEvent"				
								v-model="payload.startDate"
								v-on:change="startEndDateChange($event,'startDate')">
							</field>

							<field
								:params="{
									type: 'date'
								}"

								:readonly="!userCanWriteEvent"
								v-model="payload.repeat_until"
								v-on:change="startEndDateChange($event,'repeat_until')">
							</field>
						</div>
					</form-group>

					<form-group label="Daily Start/End Time"
						col-class="stacked">

						<div class="d-flex">
							<field
								class="flex-grow-1"
								:params="{type:'time'}"
								:readonly="!userCanWriteEvent"
								v-model="payload.startTime">
							</field>

							<field
								class="flex-grow-1"
								:params="{type:'time'}"
								:readonly="!userCanWriteEvent"
								v-model="payload.endTime">
							</field>
						</div>
					</form-group>
				</div>
				<div class="col-md-6">

					<v-calendar class="mb-3 mt-1"
						:attributes="[
							{
								dates: daysEntityScheduled,
								highlight: 'gray',
							},
							{
								dates: daysEntitySelectedToBeScheduled,
								highlight: true,
							}
						]"
						color="indigo"
						:first-day-of-week="0"
						is-expanded>
					</v-calendar>
				</div>
			</div>

			<field v-if="!startEndDayIsSame()" label="Days of Week"
				col-class="stacked"
				:params="{
					type: 'checklist',
					options: daysOfWeekOptions(),
					horizontalChecklist: true
				}"
				:readonly="!userCanWriteEvent"
				v-model="repeatItem.daysOfWeek">
				Select the days you'd like this job to be scheduled for
			</field>

		</template>
		<template v-else>

			<div v-if="isGenericUserEvent(record)">
				<field 
					class="mb-2"
					label="Type"
					col-class="col-md-2"
					:float-control-right="true"
					:params="{
						type:'btn-group',
						buttons: [
							{text:'Vacation',value:'vacation'},
							{text:'Sick Day',value:'sick'},
							{text:'Generic',value:'other'},
						],
						disableNull: true
					}"
					:readonly="!userCanWriteEvent"
					v-model="userEventType"
					v-on:change="userEventTypeChange">
				</field>

				<field v-if="isGenericUserEvent && userEventType == 'other'"
					label="Description"
					col-class="col-md-4"
					v-model="payload.title">
				</field>

			</div>

			<alert v-else-if="isOffEvent(record)" classes="alert-warning" icon="fa-ban" :visible="true" :unclosable="true">
				Scheduled OFF
			</alert>
			<!--
			<template v-if="(record.type == 'user' && userEventType == 'assignment') || record.type == 'equipment'">

				<field v-if="!payload.service_id" 
					label="Project" 
					col-class="col-md-4" 
					:params="{type: 'select', options: jobOptions}" 
					v-model="payload.job_id">
				</field>

				<field v-if="!payload.job_id" 
					label="Service" 
					col-class="col-md-4" 
					:params="{type: 'select', options: serviceOptions}" 
					v-model="payload.service_id">
				</field>
			</template>
			-->

			<template v-if="!isOffEvent(record)">
				<div>
					<label>
						<input type="checkbox" v-model="allDay" v-on:change="allDayChange">
						Full Day(s)
					</label>
				</div>

				<form-group label="Start Date/Time"
					col-class="col-md-4">

					<div class="d-flex">
						<field
							:params="{type:'date'}"
							:readonly="!userCanWriteEvent"
							v-model="payload.startDate"
							v-on:change="timeChanged">
						</field>

						<field v-if="!allDay"
							:params="{type:'time'}"
							:readonly="!userCanWriteEvent"
							v-model="payload.startTime"
							v-on:change="timeChanged">
						</field>
					</div>
				</form-group>

				<form-group label="End Date/Time"
					col-class="col-md-4">

					<div class="d-flex">
						<field
							:params="{type:'date'}"
							:readonly="!userCanWriteEvent"
							v-model="payload.endDate">
						</field>

						<field v-if="!allDay"
							:params="{type:'time'}"
							:readonly="!userCanWriteEvent"
							v-model="payload.endTime">
						</field>
					</div>
				</form-group>
			</template>

		</template>

		<template v-if="record.type == 'user' && payload.service_id > 0">
			<field label="Is Lead Technician"
				col-class="col-auto"
				:readonly="!userCanWriteEvent"
				:params="{type:'boolean'}"
				v-model="isLeadTechnician">
			</field>
		</template>

		<field v-if="record.type == 'user' && (payload.service_id > 0 || payload.job_id > 0)" label="Starting Location"
			:readonly="!userCanWriteEvent"
			col-class="col-md-4"
			:params="{type: 'select',options:[
				{text: 'Jobsite', value: 'Jobsite'},
				{text: 'Office', value: 'Office'},
				{text: 'Yard', value: 'Yard'},
				{text: 'Supplier', value: 'Supplier'}
			]}"
			v-model="payload.starting_location">
		</field> 

		<!--
		<template v-if="!('id' in record) && (record.type == 'user' || record.type == 'equipment') && (record.service_id > 0 || record.job_id > 0) && parentIsRepeatingEvent">
			<field label="Duplicate to repeated events"
				col-class="col-auto"
				:params="{type:'boolean'}"
				v-model="duplicateToRepeatedEvents">
			</field>
		</template>
		-->
		
		<!-- NOT IN USE FOR NOW
		<field v-if="repeatedEvents.length > 1 && 'id' in record && record.id > 0 && !isOffEvent(record)"
			label="Edit all occurrences of this event"
			:readonly="!userCanWriteEvent"
			col-class="col-auto"
			:params="{type:'boolean'}"
			v-model="editAllOccurences">
		</field>
		-->

		<field label="Notes"
			:readonly="!userCanWriteEvent"
			col-class="stacked"
			:params="{type: 'textarea'}"
			v-model="payload.notes">
		</field> 

		<field v-if="record.type == 'service'"
			label="Pick a lead crew member"
			col-class="col-md-5"
			:params="{
				type: 'select',
				options: availableUsersOptions
			}"
			v-model="payload.lead_technician_id"
			v-on:change="leadCrewSelected">
		</field>

		<div v-if="record.type == 'service' || record.type == 'project'">

			<template v-if="isRepeatingEvent()">
				<hr>

				<accordion heading="Repeating Event Management">
					<!--<h4>Repeating Event Management</h4>-->

					<p><strong>NOTE:</strong> Make sure to select the Days of Week selection to add to multiple events</p>

					<field v-if="!startEndDayIsSame()" label="Days of Week"
						col-class="stacked"
						:params="{
							type: 'checklist',
							options: daysOfWeekOptions(),
							horizontalChecklist: true
						}"
						:readonly="!userCanWriteEvent"
						v-model="repeatItem.daysOfWeek">
						Select the days you'd like this job to be scheduled for
					</field>

					<field 
						label="Assign employees to all repeating events"
						col-class="col-md-6"
						:params="{
							type: 'select-multi',
							options: userOptions()
						}"
						v-model="assignedUsers">
					</field>

					<form-group v-if="isRepeatingEvent()"
						label="Assign equipment to all repeating events"
						col-class="col-auto">

						<button v-if="!equipmentPickerVisible" class="btn btn-light btn-sm" v-on:click="equipmentPickerVisible = true">Select Equipment...</button>
					</form-group>

					<equipment-picker v-if="equipmentPickerVisible"
						v-on:equipmentChange="addEquipmentToAssigned">
					</equipment-picker>

					<ul class="list-group">
						<li v-for="(eq,index) in assignedEquipment" class="list-group-item">
							<div class="d-flex justify-content-between">
								<span>{{ eq.description }}</span>
								<i class="icon-button fa fa-times" v-on:click="removeEquipmentFromAssigned(index)"></i>
							</div>
						</li>
					</ul>
				</accordion>

				<hr>
				
			</template>

			<component :is="isRepeatingEvent() ? 'accordion' : 'div'" :start-open="true" heading="Individual Event Management">
				<!--<h4>Individual Event Management</h4>-->
				<table-list class="mt-4"
					record-name="Employee"
					:fields="[
						{label: '',key: 'userRoleIcon'},
						{label: 'Employee',key: 'userFullName'},
						{label: 'Start Time',key: 'startTimeFormatted'},
						{label: 'End Time',key: 'endTimeFormatted'}
					]"
					:records="mutatedScheduledEmployees"
					:has-delete="true"
					:has-edit="true"
					:hide-record-count="true"
					v-on:delete="removeChildEvent"
					v-on:edit="editChildEvent($event,'user')">

					<div class="d-flex justify-content-between">
						<h5>Scheduled Employees</h5>

						<div>
							<button class="btn btn-primary btn-sm" type="button" v-on:click="addChildToParent('user')">
								<i class="fa fa-plus"></i>
								Add Employee
							</button>
						</div>
					</div>

				</table-list>

				<table-list class="mt-4"
					record-name="Equipment Item"
					:fields="[
						{label: 'Equipment',key: 'description'},
						{label: 'Start Time',key: 'startTimeFormatted'},
						{label: 'End Time',key: 'endTimeFormatted'}
					]"
					:records="mutatedScheduledEquipment"
					:has-delete="true"
					:has-edit="true"
					:hide-record-count="true"
					v-on:delete="removeChildEvent"
					v-on:edit="editChildEvent($event,'equipment')">

					<div class="d-flex justify-content-between">
						<h5>Scheduled Equipment</h5>

						<div>
							<button class="btn btn-primary btn-sm" type="button" v-on:click="addChildToParent('equipment')">
								<i class="fa fa-plus"></i>
								Add Equipment
							</button>
						</div>
					</div>

				</table-list>
			</component>

		</div>

		<div v-if="record && 'ApprovedBy' in record && record.ApprovedBy" class="alert alert-success">Approved by {{record.ApprovedBy.first_name}} {{record.ApprovedBy.last_name}}</div>
		<div v-if="record && 'RejectedBy' in record && record.RejectedBy" class="alert alert-warning">Rejected by {{record.RejectedBy.first_name}} {{record.RejectedBy.last_name}}</div>
		<div v-if="record.approved_by == 0 && record.reject_by == 0" class="alert alert-info">Pending approval</div>

		<template v-if="userCanWriteEvent && record && 'is_vacation' in record && record.is_vacation == 1">
			<template v-if="eventApproved">
				<form-group label="Vacation" col-class="col-md-4">
					<span v-if="'ApprovedBy' in record && record.ApprovedBy"><i class="fa fa-check"></i> Approved by {{record.ApprovedBy.first_name}} {{record.ApprovedBy.last_name}}. </span>
					<a href="#" v-on:click.prevent="approveRejectVacation(record.id,0)">Withdraw approval...</a>
				</form-group>
			</template>
			<form-group v-else label="Vacation Request"
				col-class="col-md-4">
				
				<button class="btn btn btn-success" v-on:click="approveRejectVacation(record.id,1)">
					<i class="fa fa-check"></i>
					Approve...
				</button>
				<button class="btn btn btn-dark" v-on:click="approveRejectVacation(record.id,0)">
					<i class="fa fa-ban"></i>
					Reject...
				</button>

			</form-group>
		</template>

		<template slot="footer">
			<button v-if="mode == 'edit' && userCanWriteEvent" type="button" class="btn btn-outline-danger" v-on:click="deleteItem">
				<i class="fa fa-trash"></i>
				Delete Event
			</button>
		</template>

	</modal-dialog>

	<modal-dialog :modal-visible="deleteModal.visible"
		title="Delete Event"
		confirm-button-text="Confirm Delete"
		button-class="btn-outline-danger"
		v-on:confirm="confirmDeleteEvents"
		v-on:closeModal="deleteModal.visible = false">

		Are you sure you want to delete this event?

		<template>
			<field label="Delete any duplicate repeated events too"
				col-class="col-auto"
				:control-left="true"
				:params="{type:'boolean'}"
				v-model="deleteModal.deleteRelated">
			</field>
		</template>

	</modal-dialog>

	<schedule-event-edit-modal v-if="childEventModal.visible && !isChildEvent"
		:visible="childEventModal.visible"
		:create-record="childEventModal.createRecord"
		:record="childEventModal.item"
		:schedule-rows="scheduleRows"
		:projects-on-schedule="projectsOnSchedule"
		:services-on-schedule="servicesOnSchedule"
		:is-child-event="true"
		:parent-event="record"
		key="internal"
		:events-list="eventsList"
		v-on:eventSaved="childEventSaved"
		v-on:closeModal="childEventModal.visible = false">
	</schedule-event-edit-modal>

	<modal-dialog v-if="isChildEvent" 
		:modal-visible="duplicateConfirmModal.visible"
		title="Duplicate Event?"
		confirm-button-text="Yes, Duplicate"
		cancel-button-text="No"
		:working="duplicateConfirmModal.working"
		v-on:confirm="confirmDuplicateEvent"
		v-on:closeModal="closeDuplicateConfirmModal">

		Would you like to duplicate this event to future related job events?

	</modal-dialog>
</div>
</template>
<script type="text/javascript">

import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import VCalendar from "v-calendar/src/components/Calendar"
import Alert from "@/components/Alert"

import TableList from "@/components/TableList"
import Accordion from "@/components/Accordion"

import ScheduleEventEditModal from "@/components/super_components/ScheduleEventEditModal"
import EventEmployeeEntityPicker from "@/components/super_components/EventEmployeeEntityPicker"
import EquipmentPicker from "@/components/equipment_picker/EquipmentPicker"
import JobPicker from "@/components/super_components/JobPicker"

import ScheduleMixins from "@/mixins/ScheduleMixins.js"
	
export default {
	name: "ScheduleEventEditModal",
	components: {
		Field,
		ModalDialog,
		FormGroup,
		VCalendar,
		Alert,
		TableList,
		ScheduleEventEditModal,
		EventEmployeeEntityPicker,
		EquipmentPicker,
		JobPicker,
		Accordion
	},
	mixins: [ScheduleMixins],
	props: [
		"record",
		"scheduleRows",
		"visible",
		"createRecord",
		"projectsOnSchedule",
		"servicesOnSchedule",
		"isChildEvent",
		"eventsList",
		"parentEvent"
	],
	data() {
		return {
			allDay: false,
			payload: {},
			eventUser: null,
			eventService: null,
			eventProject: null,
			eventEquipment: null,
			repeatedEvents: [],
			scheduledEmployees: [],
			scheduledEquipment: [],
			working: false,
			userEventType: null,
			mode: "edit",
			isLeadTechnician: false,
			repeatItem: {
				daysOfWeek: []
			},
			deleteModal: {
				visible: false,
				deleteRelated: false
			},
			childEventModal: {
				visible: false,
				createRecord: false,
				item: {}
			},
			scheduleRowsLocal: null,
			eventApproved: false,
			duplicateToRepeatedEvents: false,
			editAllOccurences: false,
			assignedUsers: [],
			equipmentPickerVisible: false,
			assignedEquipment: []
		}
	},
	watch: {
		record() {
			this.setData()
			this.fetchRepeatedEvents()
			this.fetchChildEvents()
		},
		scheduleRows() {
			this.scheduleRowsLocal = this.scheduleRows
		},
		visible() {
			this.editAllOccurences = false
			this.duplicateToRepeatedEvents = false
			this.deleteModal.deleteRelated = false

			if (this.visible) {
				this.assignedUsers = []
				this.assignedLeadCrewMember = null

				this.setData()
				this.fetchData()
			}
		}
	},
	computed: {
		modalTitle() {
			if (this.createRecord)
				return "Add Schedule Event"
			else
				return "Edit Schedule Event"
		},
		userCanWriteEvent() {
			if (this.hasModulePermWrite("Schedule"))
				return true

			if (this.record.user_id == this.$store.userDetails.id && this.record.service_id == 0 && this.record.job_id == 0)
				return true

			return false
		},
		daysEntityScheduled() {
			let days = new Set, vm = this

			this.repeatedEvents.forEach(event => {
				days.add(this.moment(event.start_time).toISOString())
			})

			return [...days]
		},
		//days that the event will be repeated on based on checkbox selections and enddate
		daysEntitySelectedToBeScheduled() {
			let days = new Set, vm = this

			let end = this.moment(this.payload.repeat_until)

			for (var m = this.moment(this.payload.startDate); m.isSameOrBefore(end); m.add(1,"days")) {
				if (vm.repeatItem.daysOfWeek.indexOf(m.day().toString()) >= 0) {

					days.add(this.moment(m).toISOString())
				}
			}

			return [...days]
		},
		parentIsRepeatingEvent() {
			let vm = this
			let parent
			if (this.scheduleRowsLocal) {
				this.scheduleRowsLocal.forEach(row => {
					if ("items" in row && row.items) {
						let key = "job_id"
						if (vm.record.service_id > 0)
							key = "service_id"

						if (!parent) 
							parent = row.items.find(item => item[key] == vm.record[key] && (item.type == 'project' || item.type == 'service'))
					}
				})
			}

			if (parent && vm.moment(parent.repeat_until).isAfter(parent.startMoment))
				return true

			return false
		},
		projectOptionsLocal() {
			return this.optionify(this.projectsOnSchedule.map(job => {
				job.jobNumberAndName = job.job_num +" : " + job.job_name

				return job
			}),"jobNumberAndName")
		},
		serviceOptionsLocal() {
			return this.optionify(this.servicesOnSchedule.map(service => {
				service.label = service.job_num// + ": " + service.job_name

				if ("Customer" in service)
					service.label += ": "+service.Customer.name

				return service
			}),"label")
		},
		mutatedScheduledEmployees() {

			let vm = this
			return this.scheduledEmployees.map(event => {

				event.userFullName = event.User.first_name + " " + event.User.last_name
				event.startTimeFormatted = vm.formatDateTimeToLocal(event.start_time)
				event.endTimeFormatted = vm.formatDateTimeToLocal(event.end_time)

				event.userRoleIcon = ""
				if (this.payload.lead_technician_id == event.user_id || ("isLeadTechnician" in event && event.isLeadTechnician))
					event.userRoleIcon = "<i class='fa fa-vest' title='Lead crew member'></i>"
				
				return event
			})
		},
		mutatedScheduledEquipment() {
			let vm = this
			return this.scheduledEquipment.map(event => {
				event.description = event.Equipment.description
				event.startTimeFormatted = vm.formatDateTimeToLocal(event.start_time)
				event.endTimeFormatted = vm.formatDateTimeToLocal(event.end_time)

				return event
			})
		},
		availableUsersOptions() {
			let vm = this
			let parentEventStartTimeMoment = this.moment(this.payload.startDate + " " + this.payload.startTime)
			let parentEventEndTimeMoment = this.moment(this.payload.startDate + " " + this.payload.endTime)

			let scheduleSettings = {}
			try {
				scheduleSettings = JSON.parse(this.$store.company.CompanySetting.schedule_defaults_json)
			}
			catch (e) {}

			if ("enforceConflicts" in scheduleSettings && scheduleSettings.enforceConflicts == 1) {
				return this.userOptions().filter(user => {


					//check if there are conflicting events that prevent this user from being assigned
					let conflictingEvents = vm.$store.scheduleEvents.filter(event => event.user_id == user.value).find(event => {
						let eventStartMoment = vm.moment.utc(event.start_time).local()
						let eventEndMoment = vm.moment.utc(event.end_time).local()

						if (vm.eventsOverlap(eventStartMoment,eventEndMoment,parentEventStartTimeMoment,parentEventEndTimeMoment))
							return true

						return false
					})

					if (conflictingEvents)
						return false

					return true
				})
			}
			else
				return this.userOptions()
		}
	},
	methods: {
		setData() {
			let vm = this

			this.isLeadTechnician = false
			this.assignedUsers = []
			this.assignedEquipment = []

			if (this.record) {

				this.repeatItem.daysOfWeek = []

				this.payload = {
					startDate: "startMoment" in this.record ? this.record.startMoment.local().format("YYYY-MM-DD") : null,
					startTime: "startMoment" in this.record ? this.record.startMoment.local().format("HH:mm") : null,
					endDate: "endMoment" in this.record ? this.record.endMoment.local().format("YYYY-MM-DD") : null,
					endTime: "endMoment" in this.record ? this.record.endMoment.local().format("HH:mm") : null,
				}

				let mapKeys = ["user_id","equipment_id","service_id","job_id","is_sickday","is_vacation","is_off","notes","repeat_until","starting_location","type","parent_event_id","description","title","lead_technician_id","isLeadTechnician"]
				mapKeys.forEach(key => {
					if (key in this.record)
						this.payload[key] = this.record[key]
				})

				if ("User" in this.record)
					this.eventUser = this.record.User
				if ("Equipment" in this.record)
					this.eventEquipment = this.record.Equipment
				if ("Job" in this.record)
					this.eventProject = this.record.Job
				if ("Service" in this.record)
					this.eventService = this.record.Service

				if (this.record.type == 'user' || ("User" in this.record) && this.record.User) {

					if (this.record.is_vacation == 1)
						this.userEventType = 'vacation'
					else if (this.record.is_sickday == 1)
						this.userEventType = 'sick'
					else if (this.record.job_id > 0 || this.record.service_id > 0)
						this.userEventType = 'assignment'
					else
						this.userEventType = 'other'
				}

				if ("ApprovedBy" in this.record && this.record.ApprovedBy)
					this.eventApproved = true
				else
					this.eventApproved = false

				if (this.record && "isLeadTechnician" in this.record)
					this.isLeadTechnician = this.record.isLeadTechnician		
			}

			if (this.isChildEvent) {
					
			}
		},
		endTimeChange(newValue) {
			/*
			// End time cannot be before start time
			if (this.payload.startDate == this.payload.repeat_until &&
				newValue < this.payload.startTime)
			{
				this.payload.startTime = newValue
				this.$forceUpdate()
			}
			*/
		},
		startTimeChange(newValue) {
			if (this.payload.startDate == this.payload.repeat_until &&
				newValue > this.payload.endTime)
			{
				this.payload.endTime = newValue
				this.$forceUpdate()
			}
		},
		isRepeatingEvent() {
			let vm = this

			return (vm.record.type == 'project' || vm.record.type == 'service') && vm.moment(vm.payload.repeat_until).isAfter(vm.payload.startDate)
		},
		startEndDayIsSame() {
			return this.payload.startDate == this.payload.repeat_until
		},
		isGenericUserEvent(record) {
			return record.type == 'user' && (record.job_id == 0 || !record.job_id || !('job_id' in record)) && (record.service_id == 0 || !record.service_id || !('service_id' in record)) && (!record.is_off || record.is_off == 0 || !('is_off' in record))
		},
		isOffEvent(record) {
			return "is_off" in record && record.is_off == 1
		},
		jobChange(value) {
			this.$forceUpdate()
		},
		leadCrewSelected(user_id) {
			this.childEventModal.visible = true
			this.childEventModal.createRecord = true
			this.childEventModal.item = {
				job_id: this.record.job_id,
				service_id: this.record.service_id,
				type: 'user',
				startMoment: this.record.startMoment,
				endMoment: this.record.endMoment,
				starting_location: "Jobsite",
				parent_event_id: this.record.id,
				user_id,
				isLeadTechnician: true
			}

			if ("Job" in this.record)
				this.childEventModal.item.Job = this.record.Job
			if ("Service" in this.record)
				this.childEventModal.item.Service = this.record.Service
		},
		daysOfWeekOptions() {
			let options = [
				{text: 'Sunday',value:'0'},
				{text: 'Monday',value:'1'},
				{text: 'Tuesday',value:'2'},
				{text: 'Wednesday',value:'3'},
				{text: 'Thursday',value:'4'},
				{text: 'Friday',value:'5'},
				{text: 'Saturday',value:'6'},
			]

			let endDateMoment = this.moment(this.payload.repeat_until)
			let startDateMoment = this.moment(this.payload.startDate)

			let daysBetweenRange = endDateMoment.diff(this.moment(this.payload.startDate),"days")

			if (daysBetweenRange >= 7)
				return options //all days of week available

			let daysOfWeekInRange = new Set()
			for (var s = this.moment(startDateMoment); s.diff(endDateMoment, 'days') <= 0; s.add(1, 'days')) {
				daysOfWeekInRange.add(s.day())
			}

			daysOfWeekInRange = [...daysOfWeekInRange]

			return options.filter(d => daysOfWeekInRange.indexOf(+d.value) >= 0)
		},
		getKeyFromType(type) {
			let key
			if (type == 'user')
				key = "user_id"
			else if (type == 'equipment')
				key = "equipment_id"
			else if (type == 'project')
				key = "job_id"
			else if (type == 'service')
				key = "service_id"

			return key
		},
		timeChanged() {
			let vm = this

			this.$nextTick(() => {

				let endDateTime = vm.moment(vm.payload.endDate + " " + vm.payload.endTime)

				if (!endDateTime.isValid() || endDateTime.isBefore(vm.moment(vm.payload.startDate + " " + vm.payload.startTime))) 
					//can't be allowed
					vm.payload.endDate = vm.moment(vm.payload.startDate).format("YYYY-MM-DD")
			})
		},
		allDayChange(value) {
			let vm = this

			this.$nextTick(() => {
				if (vm.allDay) {
					vm.payload.startTime = "00:00"
					vm.payload.endTime = "23:59"
				}
			})
		},
		deleteItem() {
			this.deleteModal.visible = true
		},
		confirmDeleteEvents() {
			let vm = this

			this.working = true

			this.postData("ScheduleEvent/delete",{id:vm.record.id,deleteRelated: vm.deleteModal.deleteRelated},true).then(response => {
				vm.working = false

				if (response.success) {
					vm.deleteModal.visible = false

					vm.$emit("scheduleRowsUpdated",vm.scheduleRowsLocal)
					vm.$emit("eventDeleted")
					vm.$emit('closeModal')
				}
				else if ("errors" in response && response.errors.length > 0 && response.errors[0] == "A delete request has been sent to the user") {
					vm.$emit("eventDeleted")
					vm.$emit('closeModal')
					vm.deleteModal.visible = false
				}
			})
		},
		startEndDateChange(value,key) {
			this.payload[key] = value
			this.$forceUpdate()
		},
		userEventTypeChange(value) {
			if (value != 'assignment') {
				this.payload.service_id = 0
				this.payload.job_id = 0
			}
		},
		addChildToParent(type) {
			this.childEventModal.visible = true
			this.childEventModal.createRecord = true
			this.childEventModal.item = {
				job_id: this.record.job_id,
				service_id: this.record.service_id,
				type,
				startMoment: this.moment(this.payload.startDate + " " + this.payload.startTime),
				endMoment: this.moment(this.payload.endDate + " " + this.payload.endTime),
				starting_location: "Jobsite",
				parent_event_id: this.record.id
			}

			if ("Job" in this.record)
				this.childEventModal.item.Job = this.record.Job
			if ("Service" in this.record)
				this.childEventModal.item.Service = this.record.Service
		},
		userSelected(user) {
			this.childEventModal.item.user_id = user.id
			this.childEventModal.item.User = user

			this.$bus.$emit("eventUserSelected",this.childEventModal.item)
		},
		editChildEvent(record,type) {
			this.childEventModal.visible = true
			this.childEventModal.item = this.renderEventObj(record)
			this.childEventModal.item.type = type
			this.childEventModal.createRecord = false
		},
		removeChildEvent(record) {
			let vm = this

			this.postData("ScheduleEvent/delete",{id: record.id},true).then(response => {
				if (response.success) {
					vm.$emit("eventDeleted")
					vm.fetchChildEvents()
				}
			})
		},
		addEquipmentToAssigned(equipment) {
			this.assignedEquipment.push(equipment)
			this.equipmentPickerVisible = false
		},
		removeEquipmentFromAssigned(index) {
			this.assignedEquipment.splice(index,1)
		},
		saveModalEdit() {
			let vm = this

			let values = this.payload

			let startTime = values.startTime
			if (!startTime)
				startTime = "00:00"

			let endTime = values.endTime
			if (!endTime)
				endTime = "23:59:59"

			let payload = {
				start_time: this.moment(values.startDate+" "+startTime).utc().format("YYYY-MM-DD HH:mm"),
				notes: this.payload.notes
			}

			if (("user_id" in values && values.user_id > 0) || ("equipment_id" in values && values.equipment_id > 0)) {
				//child entitty
				payload.end_time = this.moment(values.endDate+" "+endTime).utc().format("YYYY-MM-DD HH:mm")
			}
			else {
				//job entity
				let endTimeDate = values.startDate
				//if end time is before start time, roll over the end-time date
				if (this.moment(values.startDate+" "+startTime).isAfter(this.moment(endTimeDate + " " + endTime)))
					endTimeDate = this.moment(endTimeDate).add(1,"days").format("YYYY-MM-DD")

				payload.end_time = this.moment(endTimeDate+" "+endTime).utc().format("YYYY-MM-DD HH:mm")
				payload.repeat_until = values.repeat_until
			}

			let mapKeys = ["user_id","equipment_id","service_id","job_id","event_id","notes","starting_location","parent_event_id","title","lead_technician_id"]
			mapKeys.forEach(key => {
				if (key in values) 
					payload[key] = values[key]
			})

			//make sure services that are linked to projects (which would have both job_id and service_id set), get the job_id removed
			if ("service_id" in payload && payload.service_id > 0)
				delete payload.job_id

			if (this.record.type == 'user') {
				if (this.userEventType == 'vacation') {
					payload.is_vacation = 1
					payload.is_sickday = 0
				}
				else if (this.userEventType == 'sick') {
					payload.is_vacation = 0
					payload.is_sickday = 1
				}
				else {
					payload.is_vacation = 0
					payload.is_sickday = 0
				}
			}

			if (this.record.type == 'user' && this.payload.service_id > 0)
				payload.isLeadTechnician = this.isLeadTechnician

			if ("id" in this.record && this.record.id)
				payload.id = this.record.id

			//if ("lead_technician_id" in payload && payload.lead_technician_id == 0)
				delete payload.lead_technician_id

			this.saveEvent(payload).then(response => {

				if (response.success) {

					if (vm.isChildEvent && ("job_id" in payload && payload.job_id > 0) && ("service_id" in payload && payload.service_id)) {

						let jobKey
						if (payload.job_id > 0) 
							jobKey = "job_id"
						else if (payload.service_id > 0) 
							jobKey = "service_id"


						//check if this job has duplicated events
						vm.fetchRelatedJobEvents(jobKey,payload[jobKey],true).then(response => {
							if (response.success && response.data.length > 1) {
								vm.duplicateConfirmModal.visible = true
								vm.duplicateConfirmModal.relatedJobEvents = response.data
								vm.duplicateConfirmModal.eventPayload = payload
							}
						})
						vm.$emit('closeModal')

					}
					else
						vm.$emit('closeModal')
					
					if (vm.record.type == 'project' || vm.record.type == 'service') {

						//create events for assigned employees & equipment to project
						let childPromises = []

						if (payload.lead_technician_id > 0) {

							let leadPayload = {
								user_id: payload.lead_technician_id,
								start_time: payload.start_time,
								end_time: payload.end_time,
								parent_event_id: response.record_id,
								isLeadTechnician: true
							}

							if ("service_id" in payload)
								leadPayload.service_id = payload.service_id
							if ("job_id" in payload)
								leadPayload.job_id = payload.job_id

							childPromises.push(vm.postData("ScheduleEvent/save",leadPayload))
						}

						vm.assignedUsers.forEach(user_id => {

							if (user_id > 0) {
								let userPayload = {
									user_id,
									start_time: payload.start_time,
									end_time: payload.end_time,
									parent_event_id: response.record_id
								}

								if ("service_id" in payload)
									userPayload.service_id = payload.service_id
								if ("job_id" in payload)
									userPayload.job_id = payload.job_id

								childPromises.push(vm.postData("ScheduleEvent/save",userPayload))
							}
						})

						vm.assignedEquipment.forEach(eq => {
							let eqPayload = {
								equipment_id: eq.id,
								start_time: payload.start_time,
								end_time: payload.end_time,
								parent_event_id: response.record_id
							}

							if ("service_id" in payload)
								eqPayload.service_id = payload.service_id
							if ("job_id" in payload)
								eqPayload.job_id = payload.job_id

							childPromises.push(vm.postData("ScheduleEvent/save",eqPayload))
						})

						Promise.all(childPromises).then(responses => {

							let errors = []
							responses.forEach(singleResponse => {
								if (!singleResponse.success) {
									if ("error" in singleResponse)
										errors.push(singleResponse.error)
									else if ("errors" in singleResponse) {
										errors = [
											...errors,
											...singleResponse.errors
										]
									}
								}
							})

							if (errors.length > 0) 
								vm.alertErrors(errors)

							vm.$emit("eventSaved")
						})
					}

					/*
					if (vm.editAllOccurences) {
						let promises = []

						let repeatingPayload = vm.cloneObj(payload)

						vm.repeatedEvents.forEach(event => {
							repeatingPayload.id = event.id
							
							repeatingPayload.start_time = vm.moment(vm.moment(event.start_time).format("YYYY-MM-DD")+" "+values.startTime).utc().format("YYYY-MM-DD HH:mm:ss")
							repeatingPayload.end_time = vm.moment(vm.moment(event.end_time).format("YYYY-MM-DD")+" "+values.endTime).utc().format("YYYY-MM-DD HH:mm:ss")

							promises.push(vm.postData("ScheduleEvent/save",repeatingPayload))
						})

						Promise.all(promises).then(response => {
							vm.$emit("eventSaved")
							vm.alertSaved("All occurences updated")
						})
					}
					elseif*/
					if (vm.isRepeatingEvent()) {
						//is a repeating job over multiple days

						//save duplicates 
						//get full event first
						vm.getJSON("ScheduleEvent/find/"+response.data.record_id).then(findResponse => {

							let keepFields = [
								"user_id",
								"job_id",
								"service_id",
								"equipment_id",
								"start_time",
								"end_time",
								"repeat_until"
							]
							let repeatingPayload = {}
							keepFields.forEach(key => {
								repeatingPayload[key] = findResponse.data[key]
							})

							vm.saveRepeatingEvents(
								repeatingPayload,
								vm.repeatItem.daysOfWeek,
								vm.moment(repeatingPayload.start_time),
								vm.moment(repeatingPayload.repeat_until),
								payload.lead_technician_id,
								vm.assignedUsers,
								vm.assignedEquipment.map(eq => eq.id)
							).then(response => {
								vm.alertSaved("Repeating events created")
								vm.$emit("eventSaved")
							})
						})
					}		
					else if (vm.duplicateToRepeatedEvents) {
						//is a child event that needs to be copied to other repeating parent events
						let job_key = "job_id"
						if (payload.service_id > 0)
							job_key = "service_id"

						let params = {
							filters: [
								[job_key, payload[job_key]],
								["start_time >=",payload.start_time],
								["is_published",0]
							]
						}

						vm.getJSON("ScheduleEvent/get",params).then(response => {
							if (response.success) {
								let promises = []

								//iterate the results, and save a duplicate child event for each one
								response.data.forEach(event => {
									let startDay = vm.moment(event.start_time).format("YYYY-MM-DD")
									let eventStartTime = vm.moment(payload.start_time).format("HH:MM:SS")

									payload.start_time = startDay+" "+eventStartTime

									//make sure daily start time is not before the parent's start time. This may occur if the start time between the source parent event differs from the duplicated event
									if (vm.moment(payload.start_time).isBefore(vm.moment(event.start_time)))
										payload.start_time = event.start_time

									let endDay = vm.moment(event.end_time).format("YYYY-MM-DD")
									let eventEndTime = vm.moment(event.end_time).format("HH:MM:SS")

									payload.end_time = endDay+" "+eventEndTime

									payload.parent_event_id = event.id

									delete payload.id

									promises.push(vm.postData("ScheduleEvent/save",payload))
								})

								Promise.all(promises).then(responses => {
									vm.$emit("eventSaved")
									vm.alertSaved("Event added to all repeating events")
								})
							}
						})

					}
					
					else
						vm.$emit("eventSaved")
				}
			})
		},
		saveRepeatingEvents(eventPayload,daysOfWeek,startMoment,untilMoment,leadUserId,helperUserIds,assignedEquipmentIds) {
			let day = startMoment

			let vm = this

			let promises = []

			let childEventPayloads = []

			let dayIndex = 0
			while (day.isBefore(untilMoment)) {
				dayIndex++

				day.add(1,"days")

				if (daysOfWeek.indexOf(day.format("d")) >= 0) {

					let payload = vm.cloneObj(eventPayload)

					payload.start_time = vm.moment(eventPayload.start_time).add(dayIndex,"days").format("YYYY-MM-DD HH:mm")
					payload.end_time = vm.moment(eventPayload.end_time).add(dayIndex,"days").format("YYYY-MM-DD HH:mm")

					delete payload.id

					promises.push(this.postData("ScheduleEvent/save",payload))

					let promiseIndex = promises.length - 1

					if (helperUserIds && helperUserIds.length > 0) {

						helperUserIds.forEach(userId => {
							payload.user_id = userId

							delete payload.equipment_id
							delete payload.notes
							
							//we'll need to also set parent_event_id, but need to get the parent event response back first, so set the index to track which parent event to attach to
							payload.promiseIndex = promiseIndex

							childEventPayloads.push(vm.cloneObj(payload))
						})
					}

					if (assignedEquipmentIds && assignedEquipmentIds.length > 0) {

						assignedEquipmentIds.forEach(eqId => {
							payload.equipment_id = eqId

							delete payload.user_id
							delete payload.notes
							
							//we'll need to also set parent_event_id, but need to get the parent event response back first, so set the index to track which parent event to attach to
							payload.promiseIndex = promiseIndex

							childEventPayloads.push(vm.cloneObj(payload))
						})
					}

					if (leadUserId > 0) {
						payload.user_id = leadUserId
						payload.isLeadTechnician = 1
						delete payload.notes
						delete payload.equipment_id

						//we'll need to also set parent_event_id, but need to get the parent event response back first, so set the index to track which parent event to attach to
						payload.promiseIndex = promiseIndex

						childEventPayloads.push(vm.cloneObj(payload))
					}
				}	
			}

			return new Promise((resolve,reject) => {
				Promise.all(promises).then(responses => {

					let childPromises = []

					childEventPayloads.forEach(childPayload => {

						if (childPayload && responses[childPayload.promiseIndex].success) {
							childPayload.parent_event_id = responses[childPayload.promiseIndex].data.record_id
							//delete childPayload.promiseIndex

							let payload = vm.cloneObj(childPayload)

							delete payload.promiseIndex

							childPromises.push(this.postData("ScheduleEvent/save",payload))
						}
					})

					Promise.all(childPromises).then(childResponses => {
						resolve(responses)
					})
				})
			})
		},
		childEventSaved() {
			this.fetchChildEvents()
			this.$emit("eventSaved")
		},
		fetchData() {
			if (this.record && this.repeatedEvents.length == 0)
				this.fetchRepeatedEvents()

			this.fetchChildEvents()

			this.fetchUsers([],false,["first_name","last_name","email"])
		},
		fetchChildEvents() {
			let vm = this

			let params = {
				filters: [
					["parent_event_id",this.record.id]
				],
				include: [
					{model: "User",fields: ["first_name","last_name"]},
					{model: "Equipment", fields: ["description","serial_num"]},
					{model: "Job", fields: ["job_num","job_name"]},
					{model: "Service", fields: ["job_num","job_name","assigned_to"]}
				]
			}

			this.getJSON("ScheduleEvent/get",params).then(response => {
				if (response.success) {
					vm.scheduledEmployees = response.data.filter(event => event.user_id > 0)
					vm.scheduledEquipment = response.data.filter(event => event.equipment_id > 0)

					//update lead techniciain id in payload
					let lead = vm.scheduledEmployees.find(event => event.is_lead_technician == 1)
					if (lead)
						vm.payload.lead_technician_id = lead.user_id
					else
						vm.payload.lead_technician_id = 0
				}
			})
		},
		fetchRepeatedEvents() {
			let vm = this

			let key = this.getKeyFromType(this.record.type)

			let filters = []

			if (key) {
				filters.push([key,this.record[key]])
			}

			let params = {}

			//make sure we don't scoop up attached users/equipment as well, we only want projects/services if this is a project/service
			if (this.record.type == 'service' || this.record.type == 'project') {
				filters.push(["user_id",0])
				filters.push(["equipment_id",0])
			}

			if (filters.length > 0)
				params.filters = filters

			return new Promise((resolve,reject) => {

				vm.getJSON("ScheduleEvent/get",params).then(response => {
					if (response.success) 
						vm.repeatedEvents = response.data
				
					resolve(response)
				})
			})
		}
	},
	created() {
		let vm = this
		this.scheduleRowsLocal = this.scheduleRows

		if (this.visible) {
			this.setData()

			this.fetchData()
		}

		this.$bus.$on("eventUserSelected",(event) => {
			if (vm.isChildEvent) { //if the main event bus is catching this... ignore its not meant for that
				vm.eventUser = event.User
				vm.payload.user_id = event.user_id
			}
		})
	}
}
</script>